// Workaround: phantomjs doesn't support Set yet! our testframework needs upgrade :/
// Copied and modified from
// Tfs/Service/WebAccess/TestManagement/Scripts/TestReporting/TestTabExtension/Filtering/TestResults.FilteringManager.ts
/// <amd-module name="Feed/Common/Types/CustomSet" />
export class CustomSet<T extends {}> {
    constructor() {
        if (typeof Set === "undefined" || typeof Set.prototype.keys !== "function") {
            this._elementsMap = {};
        } else {
            this._set = new Set<T>();
        }
    }

    public add(item: T): void {
        if (typeof Set === "undefined" || typeof Set.prototype.keys !== "function") {
            this._elementsMap[item.toString()] = true;
        } else {
            this._set.add(item);
        }
    }

    public has(item: T): boolean {
        if (typeof Set === "undefined" || typeof Set.prototype.keys !== "function") {
            return this._elementsMap[item.toString()] === true;
        } else {
            return this._set.has(item);
        }
    }

    private _elementsMap: { [key: string]: boolean } = {};
    private _set: Set<T>;
}
